export default __webpack_public_path__ + "static/media/2.17473e75.jpg";